
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from "./router";
import VueTilt from "vue-tilt.js";
import VueSweetalert2 from "vue-sweetalert2";
import SoftUIDashboard from "./medical-hospital";
import i18n from "./i18n";

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(i18n);
appInstance.use(ElementPlus)
appInstance.use(VueTilt);
appInstance.use(VueSweetalert2);
appInstance.use(SoftUIDashboard);
appInstance.mount("#app");
